import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/button';

export default class Incrementer extends Component {

  // Lifecycle

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.minus = this.minus.bind(this);
    this.plus = this.plus.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let { value } = this.state;
    const newValue = newProps.value;

    if (value !== newValue) {
      value = newValue;
      this.setState({ value });
    }
  }


  // Event handlers

  plus() {
    let { value } = this.state;
    const { max, name, onChange, stepSize } = this.props;

    if (value < max || typeof max === 'undefined') {
      value += stepSize;
    }

    this.setState({ value }, () => { onChange(value, name); });
  }

  minus() {
    let { value } = this.state;
    const { min, name, onChange, stepSize } = this.props;

    if (value > min || typeof min === 'undefined') {
      value -= stepSize;
    }

    this.setState({ value }, () => { onChange(value, name); });
  }

  // Render

  render() {
    const { value } = this.state;
    const { max, min, placeholder, unit } = this.props;

    const minusDisabled = value <= min;
    const plusDisabled = value >= max;

    const valueText = value || placeholder;

    return (
      <div className="incrementer">
        <Button
          className="incrementer__button incrementer__button--left"
          disabled={minusDisabled}
          onClick={this.minus}
        >
          <span className="icon-minus" />
        </Button>
        <div className="incrementer__value">
          {valueText}
          {unit && (<span className="incrementer__unit">{unit}</span>)}
        </div>
        <Button
          className="incrementer__button incrementer__button--right"
          disabled={plusDisabled}
          onClick={this.plus}
        >
          <span className="icon-plus" />
        </Button>
      </div>
    );
  }
}

Incrementer.defaultProps = {
  stepSize: 1,
};

Incrementer.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  stepSize: PropTypes.number,
  value: PropTypes.number,
  unit: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/incrementer/index.jsx